import NiceBox from './NiceBox';
import Spinner from './Spinner';
import CustomLink from './CustomLink';
import NiceButton from './NiceButton';
import NiceInput from './NiceInput';
import NiceModal from './NiceModal';
import NiceLink from './NiceLink';

export {NiceBox, Spinner, CustomLink, NiceButton, NiceInput, NiceModal, NiceLink}